/// <reference path="../typings/index.d.ts" />
namespace App {
  export class TopSniperMarcelo {
    private urlUpdateFiltro: string = null
    private topCartasMomento: ICartaTopSniper[] = [];
    private keyStorageCartasArmazenadas: string = 'cartasArmazenadas';
    private keyStorageUltimaVezSalvoFiltroFull: string = 'ultimaVezSalvo';
    private intervaloEmMinutosStorageTempoAtualizacaoFiltroFull: number = 180; // 3 horas em minutos
    private static excludesAssetId: any = [5740, 1605, 238384, 190871]
    private static excludesRareFlag: any = [76]

    private configuracoes: {
      filtros: {
        id_filtro_especial_piloto_a: number,
        id_filtro_especial_piloto_b: number,
        id_filtro_especial_piloto_c: number,
      },
      piloto: {
        principal: {
          raridade_minima_piloto_principal: number,
          lucro_unitario_minimo: number
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          valor_caixa_maximo: number
          preco_compra_carta_acima_de: number
          desconsiderar_poucas_cartas_acima_de: number
          quantidade_considero_poucas_cartas: number
          quantidade_indicativa_que_a_carta_esta_caindo: number
          total_cartas_relacionadas_incluir_no_filtro: number
        }
      },
      minimo_lucro_total_carta: number,
      usar_filtro_qualidade: boolean,
    } = null

    constructor(urlUpdateFiltro: string) {
      this.urlUpdateFiltro = urlUpdateFiltro
      this.configuracoes = {
        filtros: {
          id_filtro_especial_piloto_a: 93994,
          id_filtro_especial_piloto_b: 93999,
          id_filtro_especial_piloto_c: 94018,
        },
        piloto: {
          principal: {
            raridade_minima_piloto_principal: 1, // raridade minima das cartas para passar no filtro
            lucro_unitario_minimo: 15000, // a carta tem que dá no minimo esse lucro para passar no filtro
            valor_caixa_maximo: 140000, // cria filtros com o caixa limite informado.
            preco_compra_carta_acima_de: 3000, // filtrar apenas cartas que são compradas acima desse valor
            desconsiderar_poucas_cartas_acima_de: 200000, // desconsidear cartas que tem poucas unidades e são compradas acima desse valor
            quantidade_considero_poucas_cartas: 1, // quantidade de cartas que considero poucas
            quantidade_indicativa_que_a_carta_esta_caindo: 1, // quantidade de cartas que indica que a carta está caindo no momento
            lucro_unitario_minimo_cartas_relacionadas: 10000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 0
          }
        },
        minimo_lucro_total_carta: 100000, // lucro geral obtido com a carta para poder entrar no topCartas
        usar_filtro_qualidade: false
      };
    }

    public async validarRegrasUrlCarregada(urlAtual: string): Promise<string> {
      return null
    }

    public iniciarRecarregamento() {
      window.location.replace('https://futsniperweb.com.br/tyfdyagg5445drdff')
    }

    /**
   * Condição para as cartas certas que considero importantes está em minha análise
   * @param objTopCarta
   */
    public condicaoTopCartasImportantes(objTopCarta: ICartaTopSniper) {
      if (objTopCarta.lucro > this.configuracoes.minimo_lucro_total_carta && !TopSniperMarcelo.excludesAssetId.includes(parseInt(objTopCarta.asset_id as any)) && !TopSniperMarcelo.excludesRareFlag.includes(parseInt(objTopCarta.rareflag as any))) {
        this.topCartasMomento.push(objTopCarta)
      }
    }

    public async prepararTopCartas() {
      this.topCartasMomento = await Promise.all(this.topCartasMomento.map(async (item: ICartaTopSniper) => ({ ...item, player_info: await TopSniperUtil.filtrarPlayerInfoOrg(item.nome, item.resource_id) })));
      this.topCartasMomento.sort((a: any, b: any) => b.lucro - a.lucro);
      TopSniperUtil.logTopSniper('TOP_CARTAS_MARCELO', this.topCartasMomento);
      this.iniciandoAnaliseTopcartas();
    }

    private iniciandoAnaliseTopcartas() {
      // valor é o valor de compra
      // preco é o preço de venda
      // total é quantidade de cartas total encontrada
      // quantidade_mais é a quantidade de cartas encontrada a mais da ultima vez que filtrei
      // lucro_unitario é quanto de lucro a carta me dará apos ser vendida

      this.metodoTopCartasPilotoPrincipal()
    }

    public async processarTopCartasPilotoPrincipalPorRaridade(cartasPilotoPrincipal: ICartaTopSniper[]) {
      if (cartasPilotoPrincipal.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_a, cartasPilotoPrincipal[0], cartasPilotoPrincipal,
          this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro);

        if (cartasPilotoPrincipal.length > 1) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_b, cartasPilotoPrincipal[1], cartasPilotoPrincipal,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasPilotoPrincipal.length > 2) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_c, cartasPilotoPrincipal[2], cartasPilotoPrincipal,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }
      }

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL FINAL MARCELO", cartasPilotoPrincipal);
    }

    public async processarTopCartasPilotoPrincipalPorQualidade(cartasPilotoPrincipal: ICartaTopSniper[]) {
      if (cartasPilotoPrincipal.length) {
        TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_a, cartasPilotoPrincipal[0], cartasPilotoPrincipal,
          this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro);

        if (cartasPilotoPrincipal.length > 1) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_b, cartasPilotoPrincipal[1], cartasPilotoPrincipal,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasPilotoPrincipal.length > 2) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_c, cartasPilotoPrincipal[2], cartasPilotoPrincipal,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }
      }

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL QUALIDADE FINAL MARCELO", cartasPilotoPrincipal);
    }



    public async metodoTopCartasPilotoPrincipal() {
      let cartasPilotoPrincipal: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipais()
      let cartasQualidadeEspeciaisPilotoPrincipal: ICartaTopSniper[] = []

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL MARCELO", cartasPilotoPrincipal);

      if (this.configuracoes.usar_filtro_qualidade) {
        cartasQualidadeEspeciaisPilotoPrincipal = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasPilotoPrincipal)
      }

      if (this.configuracoes.usar_filtro_qualidade) {
        this.processarTopCartasPilotoPrincipalPorQualidade(cartasQualidadeEspeciaisPilotoPrincipal)
      } else {
        this.processarTopCartasPilotoPrincipalPorRaridade(cartasPilotoPrincipal)
      }

    }

    private getCartasInteresseFiltrosPrincipais(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento, quantidadeAmais: number = this.configuracoes.piloto.principal.quantidade_indicativa_que_a_carta_esta_caindo): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: ICartaTopSniper) => {
        let naoConsiderarCartasDeValorAltoComPoucaQuantidade = !(ele.valor >= this.configuracoes.piloto.principal.desconsiderar_poucas_cartas_acima_de
          && ele.total < this.configuracoes.piloto.principal.quantidade_considero_poucas_cartas);

        return ele.quantidade_mais >= quantidadeAmais
          && ele.rareflag >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.principal.valor_caixa_maximo
          && naoConsiderarCartasDeValorAltoComPoucaQuantidade;
      });
    }
  }
}
